// src/i18n/prices.ts —— 06 agent-portal A-10「我的售价」与 A-03「下级售价」只读弹层（0045 代理加价定价）[新增 key]；英文为本计划定稿
export const I18N_PRICES = {
  zh: {
    prices: '我的售价', // 导航 / 页名（page 键）
    hPrices: '名下用户按你的售价开卡与充值；留空表示沿用上级价',
    prOpenTitle: '开卡售价（USDT / 张）',
    prDepositTitle: '充值手续费率（%）',
    prColProduct: '卡产品',
    prColParent: '上级价',
    prColMine: '我的售价',
    prColEffective: '生效价',
    prColEarn: '每张赚',
    prColParentRate: '上级费率',
    prColMineRate: '我的费率',
    prColEffectiveRate: '生效费率',
    prColEarnRate: '费率差',
    prUplineAgent: '上级：{name} · {biz_no}',
    prUplinePlatform: '上级：GoodPayU 平台（上级价即平台价）',
    prBelowTip: '售价低于上级价，当前按上级价收取，请调整',
    prErrFormatOpen: '请输入不低于 0、最多 2 位小数的价格',
    prErrFormatRate: '请输入 0 到 100（不含 100）之间、最多 4 位小数的费率',
    prErrBelow: '不能低于上级价 {parent}',
    prFixErrors: '请先修正标红的售价',
    prNoChange: '售价未修改',
    prConflict: '上级售价刚刚调整，已刷新上级价，请核对后重新保存',
    prProductGone: '有卡产品状态已变化，已刷新售价表',
    prSave: '保存售价',
    prNoProducts: '暂无上架卡产品',
    prNote1: '用户按你的生效价付费：生效价 = 你的售价与上级价中较高者；留空表示沿用上级价，你这一级不赚差价。',
    prNote2: '你赚：开卡每张「生效价 − 上级价」；充值赚「按你的费率计的手续费 − 按上级费率计的手续费」。',
    prNote3: '售价不设上限。上级涨价后，如果你的售价低于上级价，会按上级价收取并标红提示，请及时调整。',
    prInherit: '沿用上级',
    toastPricesSaved: '售价已保存',
    aSubPrices: '查看售价',
    subPricesTip: '下级售价由其本人设置，你只能查看',
    subPricesClose: '关闭',
  },
  en: {
    prices: 'My prices',
    hPrices: "Your users pay your prices for cards and top-ups; leave blank to use your upline's",
    prOpenTitle: 'Card issue price (USDT / card)',
    prDepositTitle: 'Top-up fee rate (%)',
    prColProduct: 'Card product',
    prColParent: 'Upline price',
    prColMine: 'My price',
    prColEffective: 'Effective',
    prColEarn: 'Earn / card',
    prColParentRate: 'Upline rate',
    prColMineRate: 'My rate',
    prColEffectiveRate: 'Effective rate',
    prColEarnRate: 'Rate spread',
    prUplineAgent: 'Upline: {name} · {biz_no}',
    prUplinePlatform: 'Upline: GoodPayU (platform prices)',
    prBelowTip: "Below your upline's price — the upline's price is charged. Please adjust.",
    prErrFormatOpen: 'Enter a price of 0 or more with up to 2 decimals',
    prErrFormatRate: 'Enter a rate from 0 to below 100 with up to 4 decimals',
    prErrBelow: "Cannot be lower than the upline's {parent}",
    prFixErrors: 'Fix the prices marked in red first',
    prNoChange: 'No price changed',
    prConflict: "Your upline's prices just changed and were refreshed. Review and save again.",
    prProductGone: 'A card product changed; the price table was refreshed',
    prSave: 'Save prices',
    prNoProducts: 'No card products on sale',
    prNote1: "Users pay your effective price: the higher of your price and your upline's. Leave blank to use your upline's price (you earn no markup).",
    prNote2: "You earn (effective − upline price) per card, and on top-ups the fee at your rate minus the fee at your upline's rate.",
    prNote3: "There is no ceiling. If your upline raises prices above yours, the upline's price is charged and the row turns red — please adjust.",
    prInherit: 'Upline price',
    toastPricesSaved: 'Prices saved',
    aSubPrices: 'Prices',
    subPricesTip: 'Sub-agents set their own prices; view only',
    subPricesClose: 'Close',
  },
} as const;
